import { Box, Stack, Typography } from "@mui/material"
import { Trans, useTranslation } from "react-i18next"

import InfoButton from "./InfoButton"

const ComparedWith = ({ range }: { range: string }) => {
  const { t } = useTranslation()
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      sx={{ alignSelf: { mobile: "flex-start", tablet: "flex-end" } }}
    >
      <Typography variant="body3" color="mockup.neutral30" fontWeight={500}>
        <Trans
          i18nKey="adminDashboard.comparedWith"
          values={{ range }}
          components={{
            Range: (
              <Box component="span" color="mockup.neutral10" fontWeight={700} />
            ),
          }}
        />
      </Typography>
      <InfoButton
        label={t("adminDashboard.aboutComparedWith")}
        info={t("adminDashboard.comparedWithInfo")}
      />
    </Stack>
  )
}

export default ComparedWith
